import { createMachine } from 'xstate'
import { EventId, StateId } from './consts'
import { Context, State } from './Types'

export const brandKitCreationMachine = createMachine<Context, Event, State>(
  {
    id: 'brandKitCreation',
    initial: StateId.Instructions,
    context: {
      brandKit: null,
      redirectTo: '/',
    },
    states: {
      [StateId.Instructions]: {
        on: {
          [EventId.Next]: StateId.Form,
        },
      },
      [StateId.Form]: {
        on: {
          [EventId.Next]: StateId.Colors,
          [EventId.Back]: StateId.Instructions,
        },
      },
      [StateId.Colors]: {
        on: {
          [EventId.Next]: StateId.Images,
          [EventId.Back]: StateId.Form,
        },
      },
      [StateId.Images]: {
        on: {
          [EventId.Next]: StateId.Voice,
          [EventId.Back]: StateId.Colors,
        },
      },
      [StateId.Voice]: {
        on: {
          [EventId.Next]: StateId.Finished,
          [EventId.Back]: StateId.Images,
        },
      },
      [StateId.Finished]: {
        on: {
          [EventId.Next]: StateId.Done,
          [EventId.Back]: StateId.Voice,
        },
      },
      [StateId.Done]: {
        type: 'final',
        entry: 'onFinish',
      },
    },
  },
  {
    // Implementation for actions and guards used above
    actions: {
      onFinish: (ctx) => {
        // finalize or dispatch
      },
    },
  },
)
